/** Per-device posture exclusion keys (must match backend). */

export const POSTURE_EXCLUSION_OPTIONS = [
  { key: 'ram', label: 'Installed RAM', group: 'Hardware' },
  { key: 'processor', label: 'CPU cores / speed', group: 'Hardware' },
  { key: 'small_drive', label: 'Small system drive', group: 'Hardware' },
  { key: 'disk_free', label: 'Low / critical free disk space', group: 'Hardware' },
  { key: 'bios_age', label: 'BIOS age', group: 'Hardware' },
  { key: 'bitlocker', label: 'BitLocker / drive encryption', group: 'Security' },
  { key: 'tpm_secure_boot', label: 'TPM / Secure Boot / UEFI', group: 'Security' },
  { key: 'office_macros', label: 'Office macros', group: 'Security' },
  { key: 'windows_firewall', label: 'Windows Firewall', group: 'Security' },
  { key: 'dotnet6', label: '.NET 6 (EOL)', group: 'Security' },
]

export function normaliseExclusions(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {}
  const out = {}
  for (const { key } of POSTURE_EXCLUSION_OPTIONS) {
    if (raw[key] === true) out[key] = true
  }
  return out
}

export function isExcluded(exclusions, key) {
  return Boolean(exclusions && exclusions[key] === true)
}

export function exclusionCount(exclusions) {
  return Object.keys(normaliseExclusions(exclusions)).length
}

export function exclusionLabels(exclusions) {
  const normalised = normaliseExclusions(exclusions)
  return POSTURE_EXCLUSION_OPTIONS.filter((opt) => normalised[opt.key]).map(
    (opt) => opt.label,
  )
}
